import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import {
  IPopoverConfig,
  PopoverTemplateComponent
} from '@shared/components/popoverTemplate/popover-template.component';

@Injectable({
  providedIn: 'root'
})
export class PopoverService {

  private isActive: boolean;

  constructor(private popoverController: PopoverController) {
  }

  public show(config: IPopoverConfig): Promise<void> {
    if (!this.isActive) {
      return this.popoverController.create({
        component: PopoverTemplateComponent,
        animated: false,
        componentProps: {config},
        cssClass: config?.cssClass
      }).then((element: HTMLIonPopoverElement) => {
        this.isActive = true;
        element.onDidDismiss().then(() => {
          this.isActive = false;
        });
        return element.present();
      });
    } else {
      return Promise.resolve();
    }
  }

  public hide(): void {
    if (this.isActive) {
      this.popoverController.dismiss();
      this.isActive = false;
    }
  }

  /**
   * Safely dismisses the top popover if one exists.
   * Prevents "overlay does not exist" errors by checking before dismissing.
   * @param data Optional data to pass back when dismissing
   * @param role Optional role for the dismiss action
   * @returns Promise that resolves when the popover is dismissed, or immediately if no popover exists
   */
  public async safeDismiss(data?: any, role?: string): Promise<boolean> {
    const popover = await this.popoverController.getTop();
    if (popover) {
      await this.popoverController.dismiss(data, role);
      return true;
    }
    return false;
  }
}
